import React from 'react';
import { Header, Footer } from '../../component/index';

const Contact = () => {
    return (
        <>
        <Header homepage={false} />
        <div className="wrapper">
            <div className="container">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="page-title-box">
                            <h4 className="page-title">Contact US</h4>
                        </div>
                    </div>
                </div>
                <div className="flex-container">
                    <div className="row">
                        <div className="title_underline"></div>
                    </div>
                </div>
                <div className="row justify-content-center">
                    <div className="col-sm-12 col-md-8">
                        <div className="card-box">
                            <form role="form" name="ajax-form" autoComplete="off" action="#" method="post" className="contact-form" data-parsley-validate="">
                                <div className="form-group">
                                    <input className="form-control" id="name2" name="name" placeholder="Name" type="text" defaultValue="" required=""/>
                                </div>
                                <div className="form-group">
                                    <input className="form-control" id="email2" name="email" type="email" placeholder="Email" defaultValue="" required=""/>
                                </div>
                                <div className="form-group" >
                                    <select className="form-control col-sm-12 custom-select">
                                        <option value="region">Region</option>
                                        <option value="asia">Asia</option>
                                        <option value="sa">South America</option>
                                        <option value="eu">Europe</option>
                                    </select>
                                </div>
                                <div className="form-group">
                                    <textarea className="form-control" id="message2" name="message" rows="0" placeholder="Your requirement (up to 255 characters)" required=""></textarea>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="">
                                            <button type="submit" className="btn btn-primary btn-block radius-0" id="send">Send</button>
                                        </div> 
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div className="row m-t-50 m-b-50">
                    <div className="col-md-4 card-body">
                        <h4 className="header-title text-dark"><span>U</span>.S.A</h4>
                        <p className="text-muted font-16">Tel:+1-510-8976600</p>
                        <p className="text-muted font-16">Fax:+1-510-8976606</p>
                        <p className="text-muted font-16">Address:46520 Fremont Blvd, Suite 610, Fremont, CA 94538</p>
                        <p className="text-muted font-16">E-mail:sales@penpowerinc.com</p>
                    </div>
                    <div className="col-md-4 card-body">
                        <h4 className="header-title text-dark"><span>H</span>ong Kong</h4>
                        <p className="text-muted font-16">Tel:+1-510-8976600</p>
                        <p className="text-muted font-16">Fax:+1-510-8976606</p>
                        <p className="text-muted font-16">Address:46520 Fremont Blvd, Suite 610, Fremont, CA 94538</p>
                        <p className="text-muted font-16">E-mail:sales@penpowerinc.com</p>
                    </div>
                    <div className="col-md-4 card-body">
                        <h4 className="header-title text-dark"><span>G</span>uangzhou</h4>
                        <p className="text-muted font-16">Tel:+1-510-8976600</p>
                        <p className="text-muted font-16">Fax:+1-510-8976606</p>
                        <p className="text-muted font-16">Address:46520 Fremont Blvd, Suite 610, Fremont, CA 94538</p>
                        <p className="text-muted font-16">E-mail:sales@penpowerinc.com</p>
                    </div>
                    <div className="col-md-4 card-body">
                        <h4 className="header-title text-dark"><span>T</span>aiwan</h4>
                        <p className="text-muted font-16">Tel:+1-510-8976600</p>
                        <p className="text-muted font-16">Fax:+1-510-8976606</p>
                        <p className="text-muted font-16">Address:46520 Fremont Blvd, Suite 610, Fremont, CA 94538</p>
                        <p className="text-muted font-16">E-mail:sales@penpowerinc.com</p>
                    </div>
                    <div className="col-md-4 card-body">
                        <h4 className="header-title text-dark"><span>S</span>ingapore</h4>
                        <p className="text-muted font-16">Tel:+1-510-8976600</p>
                        <p className="text-muted font-16">Fax:+1-510-8976606</p>
                        <p className="text-muted font-16">Address:46520 Fremont Blvd, Suite 610, Fremont, CA 94538</p>
                        <p className="text-muted font-16">E-mail:sales@penpowerinc.com</p>
                    </div>
                    <div className="col-md-4 card-body">
                        <h4 className="header-title text-dark"><span>O</span>ther</h4>
                        <p className="text-muted font-16">Tel:+1-510-8976600</p>
                        <p className="text-muted font-16">Fax:+1-510-8976606</p>
                        <p className="text-muted font-16">Address:46520 Fremont Blvd, Suite 610, Fremont, CA 94538</p>
                        <p className="text-muted font-16">E-mail:sales@penpowerinc.com</p>
                    </div>
                </div>
            </div>
            <div className="above-footer"></div>
        </div>        
        <Footer/>
        </>
    )
}

export default Contact;